import { Capacitor } from '@capacitor/core';

var native_env_list = {
	ios: {
		name: 'www.mares-libellules.fr',
		scheme: 'https',
		script: 'api.php',
	},

	android: {
		name: 'www.mares-libellules.fr',
		scheme: 'https',
		script: 'api.php'
	}
};

var web_env_list = {
	dev: {
		debug: true,
		name: 'mares.localhost:8000',
		scheme: 'http',
		script: 'api_dev.php'
	},
	prod: {
		name: 'www.mares-libellules.fr',
		scheme: 'https',
		script: 'api.php'
	}
};

var host;
var envKey;
var debug;
var logging;

// Variables injectées au build depuis .env.[mode] (Vite)
var envHost   = import.meta.env.VITE_API_HOST;
var envScheme = import.meta.env.VITE_API_SCHEME;
var envScript = import.meta.env.VITE_API_SCRIPT;
var envDebug  = import.meta.env.VITE_DEBUG;
var envMercure = import.meta.env.VITE_MERCURE_PUBLIC_URL;

// Construit l'hôte API à partir des VITE_* si les trois sont définis
function hostFromEnv()
{
	if( !( envHost && envScheme && envScript ) )
		return null;

	var fromEnv = { name: envHost, scheme: envScheme, script: envScript };
	if( envDebug !== undefined )
		fromEnv.debug = envDebug === 'true' || envDebug === true;
	return fromEnv;
}

if( Capacitor.isNativePlatform() )
{
	envKey = Capacitor.getPlatform();
	host = hostFromEnv() || Object.assign( {}, native_env_list[ envKey ] );
	debug = !!host.debug;
	logging = !!host.logging;
}
else
{
	var fromEnv = hostFromEnv();
	if( fromEnv )
	{
		host = fromEnv;
		envKey = host.debug ? 'dev' : 'prod';
	}
	else
	{
		envKey = [ 'localhost', '127.0.0.1', '::1', 'mares.localhost' ].indexOf( window.location.hostname ) >= 0 ? 'dev' : 'prod';
		host = Object.assign( {}, web_env_list[ envKey ] );
	}

	var profile = web_env_list[ envKey ] || web_env_list.prod;
	debug = host.debug !== undefined ? !!host.debug : !!profile.debug;
	logging = !!profile.logging;
}

host.root = host.scheme + '://' + host.name;
host.base = host.root + '/' + host.script;


export default {

	debug: debug,
	logging: logging,

	host: host,

	ign_key: 'decouverte',

	page_size: 20,

	image: {
		type: 'image/jpeg',
		size: 1600,
		quality: 0.85
	},

	geolocation: {
		enableHighAccuracy: true,
		timeout: 1000 * 10,
	},

	map: {
		attributionControl: false,
		zoomControl: false,
		minZoom: 12,
		maxZoom: 21,
		maxNativeZoom: 19,
	},

	status_list: {
		"new":     { name: 'À confirmer'  , class: "warning", color: "warning text-white" },
		"snaped":  { name: 'À décrire'    , class: "info"   , color: "info"               },
		"visited": { name: 'Décrite'      , class: "success", color: "success"            },
		"lost":    { name: 'Non retrouvée', class: "danger" , color: "danger"             },
	},

	url: {
		zone: host.base + '/zone',
		user: host.base + '/user',
		pond: host.base + '/pond',
		visit: host.base + '/visit',
		image: host.base + '/image',

		data: host.base + '/default/data.json',
		login: host.base + '/default/login',
		register: host.base + '/default/register',
		mercure_token: host.base + '/default/mercure.json',
	},

	mercure: {
		url: envMercure || null,
	},

	file: {
		zone: 'zone_list.json',
		user: 'user.json',
		pond: 'pond_list.json',
		visit: 'visit_list.json',
		image: 'image_list.json',

		data: 'data.json',
		settings: 'settings.json',
	},
};
